import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useT } from "../lib/i18n";
import { toast } from "sonner";
import { HERO_BG } from "../lib/shop";

export default function Register() {
  const { register } = useAuth();
  const { t } = useT();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success(t("auth.signup.success"));
      nav("/cont");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : t("auth.signup.error"));
    } finally { setLoading(false); }
  };

  const fields = [
    { k: "name",     l: t("auth.fullname") },
    { k: "email",    l: t("auth.email"), t: "email" },
    { k: "phone",    l: t("auth.phone") },
    { k: "password", l: t("auth.password.long"), t: "password" },
  ];

  return (
    <div className="grid lg:grid-cols-2 min-h-[calc(100vh-5rem)]" data-testid="register-page">
      <div className="hidden lg:block relative overflow-hidden bg-silver-shimmer">
        <img src={HERO_BG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-70 mix-blend-luminosity" />
        <div className="absolute inset-0 bg-gradient-to-br from-white/40 to-transparent" />
        <div className="absolute bottom-10 left-10 right-10 text-gray-900">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-gray-500">ANAIZA · SHOP</p>
          <p className="font-display text-3xl font-black tracking-tighter mt-3 leading-tight">{t("auth.hero.signup")}</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-8 md:p-16">
        <form onSubmit={submit} className="w-full max-w-md">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-gray-400">{t("auth.signup.eye")}</p>
          <h1 className="font-display text-4xl font-black tracking-tighter mt-3">{t("auth.signup.title")}</h1>

          <div className="mt-10 space-y-6">
            {fields.map((f) => (
              <div key={f.k}>
                <label className="block text-[10px] uppercase tracking-[0.2em] text-gray-500 mb-2">{f.l}</label>
                <input type={f.t || "text"} required value={form[f.k]} onChange={(e) => setForm({ ...form, [f.k]: e.target.value })}
                  className="w-full border-b border-gray-300 bg-transparent py-2 focus:border-gray-900 focus:outline-none" data-testid={`register-${f.k}`} />
              </div>
            ))}
          </div>

          <button type="submit" disabled={loading} className="mt-10 w-full bg-gray-900 text-white py-4 font-semibold uppercase tracking-wider text-sm hover:bg-gray-800 transition disabled:opacity-60" data-testid="register-submit">
            {loading ? t("auth.signup.loading") : t("auth.signup.action")}
          </button>

          <p className="mt-6 text-sm text-gray-500">
            {t("auth.haveaccount")} <Link to="/login" className="text-gray-900 font-semibold underline-offset-4 hover:underline">{t("auth.signin")}</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
